// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';
// Section for type definition -----------------------------------------------------------------------------------------
import { MansionMarketPriceHistoryContextType } from '@/types/components/MansionDetail/MarketPriceHistoryPropsData';

const initMansionMarketPriceHistory: MansionMarketPriceHistoryContextType = {
  marketPriceHistoryData: false,
  averageSquareMeter: 0,
  selectedSquareMeter: 0,
  rangeOfYear: 1,
};
export const MansionMarketPriceHistoryContext: React.Context<MansionMarketPriceHistoryContextType> =
  createContext<MansionMarketPriceHistoryContextType>(initMansionMarketPriceHistory);
export const UpdateMansionMarketPriceHistory: React.Context<any> = createContext(initMansionMarketPriceHistory);
// export const SelectedCitiesConsumer = SelectedCitiesContext.Consumer;
export const useMansionMarketPriceHistory = () => useContext(MansionMarketPriceHistoryContext);
export const useUpdateMansionMarketPriceHistory = () => useContext(UpdateMansionMarketPriceHistory);
function MansionMarketPriceHistoryProvider(props: any): React.JSX.Element {
  const { children, mansionMarketPriceHistory } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [stateMansionMarketPriceHistory, setMansionMarketPriceHistory] = useState(mansionMarketPriceHistory);
  // valueにグローバルに扱う値を設定

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MansionMarketPriceHistoryContext.Provider value={mansionMarketPriceHistory}>
      <UpdateMansionMarketPriceHistory.Provider value={setMansionMarketPriceHistory}>
        {children}
      </UpdateMansionMarketPriceHistory.Provider>
    </MansionMarketPriceHistoryContext.Provider>
  );
}

export default MansionMarketPriceHistoryProvider;
